'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/7/6.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _GoeasyPreloadImg = require('../GoeasyPreloadImg/GoeasyPreloadImg');

var _GoeasyPreloadImg2 = _interopRequireDefault(_GoeasyPreloadImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopOrDesignerProductInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ShopOrDesignerProductInfo, _Component);

  function ShopOrDesignerProductInfo() {
    (0, _classCallCheck3.default)(this, ShopOrDesignerProductInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ShopOrDesignerProductInfo).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(ShopOrDesignerProductInfo, [{
    key: 'mouseOver',
    value: function mouseOver() {
      this.setState({
        hover: true
      });
    }
  }, {
    key: 'mouseLeave',
    value: function mouseLeave() {
      this.setState({
        hover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ShopOrDesignerProductInfo.scss');
      var _props = this.props;
      var index = _props.index;
      var product = _props.product;
      var defaultImg = _props.defaultImg;
      var isCustom = _props.isCustom;
      var hover = this.state.hover;

      var rightClassName = '';
      if ((index + 1) % 3 === 0) {
        rightClassName = styles.mr0 + ' ' + styles.w420;
      }
      var hudsClassName = styles.huds;
      if (hover === true) {
        hudsClassName = hudsClassName + ' ' + styles.hongd;
      } else if (hover === false) {
        hudsClassName = hudsClassName + ' ' + styles.hong;
      }
      var path = '/product/' + product.productId;
      if (isCustom) {
        path = '/customproduct/' + product.productId;
      }
      var price = 0;
      var priceStr = '';
      if (product.price && product.price.length > 0) {
        price = parseFloat(product.price, 10);
        if (price > 0) {
          priceStr = product.price;
        } else {
          if (product.isAppreciationGoods === '1') {
            priceStr = '鉴赏品(非卖)';
          } else {
            priceStr = '销售价待定';
          }
        }
      } else {
        priceStr = '销售价待定';
      }
      return _react2.default.createElement(
        'li',
        { onMouseOver: this.mouseOver.bind(this), onMouseLeave: this.mouseLeave.bind(this),
          className: styles.component + ' ' + rightClassName },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: path, target: '_blank' },
          _react2.default.createElement(
            'dl',
            null,
            _react2.default.createElement(
              'dd',
              null,
              _react2.default.createElement(_GoeasyPreloadImg2.default, { defaultImg: defaultImg, img: product.img }),
              _react2.default.createElement(
                'div',
                { className: styles.hotorexperience },
                product.isExperienceProduct === '1' ? _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/baokuan1.png', className: styles.hot }) : '',
                product.isExperienceGoods === '1' ? _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/tiyanpin.png',
                  className: styles.hot }) : '',
                product.isAppreciationGoods === '1' ? _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/home/appreciation.png',
                  className: styles.hot }) : ''
              )
            ),
            _react2.default.createElement(
              'dt',
              { style: { position: 'relative', width: rightClassName !== '' ? 418 : 419 } },
              _react2.default.createElement(
                'div',
                { className: hudsClassName },
                _react2.default.createElement(
                  'div',
                  { className: styles.hud + ' ' + styles.col,
                    style: { width: rightClassName !== '' ? 418 : 419, position: 'relative' } },
                  _react2.default.createElement(
                    'h3',
                    { className: styles.productName },
                    product.name
                  ),
                  _react2.default.createElement(
                    'h3',
                    { className: styles.productType },
                    product.productType
                  ),
                  _react2.default.createElement(
                    'h3',
                    { className: styles.productSize },
                    product.size
                  ),
                  product.authorImg || product.shopImg ? _react2.default.createElement('img', { className: styles.image, src: product.authorImg || product.shopImg, alt: '' }) : ''
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.hudd },
                _react2.default.createElement(
                  'div',
                  { className: styles.hud },
                  _react2.default.createElement(
                    'h3',
                    null,
                    '产地 • ' + product.placeOfOrigin
                  ),
                  product.meterial ? _react2.default.createElement(
                    'h4',
                    null,
                    '材质 • ' + product.meterial
                  ) : ''
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.hud + ' ' + styles.secondHud },
                  product.author ? _react2.default.createElement(
                    'h3',
                    null,
                    '作者 • ' + product.author
                  ) : '',
                  product.shop ? _react2.default.createElement(
                    'h3',
                    null,
                    '店铺 • ' + product.shop
                  ) : ''
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.hud + ' ' + styles.thirdHud,
                    style: { width: rightClassName !== '' ? 138 : 139 } },
                  _react2.default.createElement(
                    'h3',
                    null,
                    (product.isAppreciationGoods === '1' ? '' : '¥ ') + priceStr
                  ),
                  product.inStock ? _react2.default.createElement(
                    'h4',
                    { style: { display: product.isAppreciationGoods === '1' ? 'none' : 'block' } },
                    '库存 ' + product.inStock
                  ) : ''
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ShopOrDesignerProductInfo;
}(_react.Component), _class.propTypes = {
  index: _react.PropTypes.number.isRequired,
  product: _react.PropTypes.object.isRequired,
  defaultImg: _react.PropTypes.string,
  isCustom: _react.PropTypes.bool,
  isDesigner: _react.PropTypes.bool,
  page: _react.PropTypes.string
}, _temp);
exports.default = ShopOrDesignerProductInfo;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ShopOrDesignerProductInfo/ShopOrDesignerProductInfo.js
 ** module id = 1426
 ** module chunks = 0
 **/